module.exports = __webpack_public_path__ + "img/EGS_icon_05.031e2a2d.svg";